<template>
  <a-modal
  :visible="hidden"
  v-if="hidden"
  @ok="ok" 
  @cancel="cancel"
  :title="item.name"
  width="1000px"
  :maskClosable="false"
  :forceRender="true"
  :bodyStyle="{padding:'10px'}"
  :footer="false"
  okText="关闭"
  cancelText="取消">
    <a-row type="flex" align="middle" justify="space-between" style="padding:0 0 10px 0">
      <base-list-select :value="selectType" @change="typeChange" category="nutritiontarget" placeholder="选择类型" style="width:300px" />
    </a-row>
      <a-table
        :columns="columns"
        :loading="nutLoading"
        :data-source="list.records"
        :row-key="record => record.id"
        :scroll="{ x:400, y: 600 }"
        :pagination="false"
      />
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'
export default {
  components: { BaseListSelect },
  props:['item','hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      nutLoading:false,
      list:{
        records:[]
      },
      filterData:{},
      selectType:[],
      columns:[
        {
          title:"指标名称",
          dataIndex:"nutritionName",
        },
        {
          title:"代码",
          dataIndex:"nutritionCode",
          align:"center",
        },
        {
          title:"类型",
          dataIndex:'typeName',
        }
      ]
    }
  },
  watch:{
    hidden(val){
      val ? this.getList() : this.restList()
    },
    item(val){
      if(val){
        this.getList()
      }
    }
  },
  methods:{
    restList(){
      this.selectType = []
    },
    ok(){
      this.$emit('ok')
    },
    cancel(){
      this.$emit('cancel')
    },
    getList(arg ={}){
      this.fetchGet({
        actions:this.nutritionTypeInfoPage,
        name:'list',
        loading:'nutLoading',
        isList: true,
        data:{
          linkId: this.item.id,
          animalId: this.detail.animalTypeCode,
          ...arg,
          size:1000
        }
      })
    },
    typeChange(val){
      this.selectType = val
      this.getList({typeId:[...val].pop()})
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>
